import { Group } from "src/app/models/group.model"
import { Component } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { SearchPipe } from "src/app/pipes/search.pipe"
import { ToastService } from "src/app/services/toast/toast.service"
import { GroupService } from "src/app/services/group/group.service"
import { moveItemInArray } from "@angular/cdk/drag-drop"
import { DialogService } from "src/app/services/modal/dialog.service"
import { LogsheetService } from "src/app/services/logsheet/logsheet.service"
import { ErrorHandlerService } from "src/app/services/errorHandler/error-handler.service"
import { TempGroup } from "src/app/models/tempgroup.model"
import { isEqual } from "lodash"

interface GroupAssignment {
  tempGroup: TempGroup,
  accessDeadline: string
}

@Component({
  standalone: false,
  selector: 'app-assign-temp-form',
  templateUrl: './assign-temp-form.component.html',
  styleUrls: ['./assign-temp-form.component.css']
})

export class AssignTempFormComponent {
  selectedValues = {
    company: {
      companyId: 0,
      companyName: '',
    },
    plant: {
      plantId: 0,
      plantName: '',
    },
    unit: {
      unitId: 0,
      unitName: '',
    },
  }

  logSheetName: string = ''

  activeGroups: TempGroup[] = []
  selectedGroups: GroupAssignment[] = []
  initialSelections: GroupAssignment[] = []
  activeStep = 1
  currentRole: any
  errorMessage = {
    success: true,
    message: '',
  }
  itemArray: any = []
  firstRender = false
  searchText: String = ''
  logSheetTemplateId = ''
  assignLogsheetRequest: any = {
    groupId: [],
  }

  allDeadlinesSet(): boolean {
    if (this.selectedGroups.find(group => group.accessDeadline == '')) {
      return false;
    }
    return true;
  }

  constructor(
    private groupService: GroupService,
    private route: ActivatedRoute,
    private router: Router,
    public toastService: ToastService,
    public dialogService: DialogService,
    public logsheetService: LogsheetService,
    private errorService: ErrorHandlerService,
  ) { }

  addGroup(data: TempGroup) {
    this.selectedGroups.push({ tempGroup: data, accessDeadline: '' })
  }

  removeGroup(index: number) {
    this.selectedGroups.splice(index, 1)
  }

  sortgroupName() {
    this.selectedGroups.sort((a: any, b: any) => {
      const groupNameA = (a.tempGroup?.groupName || '').toUpperCase()
      const groupNameB = (b.tempGroup?.groupName || '').toUpperCase()
      if (groupNameA < groupNameB) {
        return -1
      }
      if (groupNameA > groupNameB) {
        return 1
      }
      return 0
    })
  }

  transferData() {
    this.firstRender = true
    this.router.navigateByUrl('settings/forms', {
      state: {
        selectedValues: { ...this.selectedValues },
        firstRender: this.firstRender,
      },
    })
  }

  isSelectedGroup(dataPoint: TempGroup) {
    var index = this.selectedGroups.findIndex(
      (x: GroupAssignment) => x.tempGroup.tempUserGroupId == dataPoint.tempUserGroupId,
    )
    return index >= 0
  }

  assignmentChanged() {
    return isEqual(this.selectedGroups, this.initialSelections);
  }

  ngOnInit(): void {
    this.selectedValues = history?.state?.selectedValues
    this.logSheetName = history?.state?.logSheetName
    this.route.paramMap.subscribe({
      next: (params) => {
        const id = params.get('id')
        if (id) {
          this.logsheetService
            .retrieveLogsheetRelative(id)
            .subscribe({
              next: (response: any) => {
                this.logSheetTemplateId =
                  response.logSheetTemplateId
                this.logsheetService
                  .retrieveSelectedTempFormTemplate(
                    response.logSheetTemplateId,
                  )
                  .subscribe({
                    next: (response) => {
                      for (
                        let i = 0;
                        i < response.length;
                        i++
                      ) {
                        this.selectedGroups.push({
                          tempGroup:
                            response[i].tempUserGroup,
                          accessDeadline:
                            response[i].accessExpirationDate,
                        })
                      }
                      this.initialSelections = structuredClone(this.selectedGroups);
                      this.sortgroupName()
                    },
                    error: (response) => {
                      this.errorMessage =
                        this.errorService.handleRetrievalErrors(
                          response,
                        )
                    },
                  })
              },
              error: (response) => {
                this.errorMessage =
                  this.errorService.handleRetrievalErrors(
                    response,
                  )
              },
            })
        }
      },
    })
    this.groupService
      .retrieveActiveTempGroupPlant(this.selectedValues?.plant?.plantId)
      .subscribe({
        next: (groups) => {
          this.activeGroups = groups.filter(
            (group) => !group.isDeleted,
          )
        },
        error: (err) => {
          this.errorMessage =
            this.errorService.handleRetrievalErrors(err)
        },
      })
  }

  loading = false
  enableSubmitBtn() {
    return !this.loading && this.allDeadlinesSet() && !this.assignmentChanged()
    // return this.selectedGroups.length > 0 && !this.loading && this.allDeadlinesSet()
  }

  assignLogsheet() {
    this.loading = true

    const payload = {
      formAssignment: this.selectedGroups.map((group) => ({
        groupId: group.tempGroup.tempUserGroupId,
        accessDeadline: group.accessDeadline
      }))
    }
    this.logsheetService
      .assignTempForm(this.logSheetTemplateId, payload)
      .subscribe({
        next: (response) => {
          this.transferData()
          this.toastService.showToast = true;
          this.toastService.toastText = `Form has been temporarily assigned`;
          setTimeout(() => {
            this.toastService.showToast = false;
          }, 3000);
        },
        error: (response) => {
          this.errorService.handleError(
            response,
            'Error assigning form',
          )
        },
      })
  }
}
